<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="heading_id_2"><a id="page_ii"></a><a id="page_iii"></a></h1>
<p class="IVPh1" id="toc">Cat &amp; Dog Prayer</p>
<p class="IVPh3">Rethinking Our Conversations with Our Master</p>
<p class="IVPh3">Bob Sjogren and Gerald Robison</p>
<p class="pub"><img alt="IVP Books Imprint" src="Images/IVP_Books_Quarter.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?6a5f22d2